<script lang="ts">
    import tabIcon from "@/assets/gear.svg";
    import BaseTab from "@/tabs/mixins/BaseTab";

    export default {
        extends: BaseTab,
        name: "BesoksunderlagSkapaRedigera",
        tabName: "Besöksunderlag",
        icon: tabIcon,
        patientBound: true,
    };
</script>

<script setup lang="ts">
    import { computed, ref, toRefs } from "vue";

    import { useStore } from "@/store";

    const store = useStore();

    const props = defineProps<{
        tabId: number;
        parameters: any;
    }>();

    const { tabId, parameters } = toRefs(props);

    const besoksunderlagId = parameters?.value?.besoksunderlagId ?? null;

    defineExpose({});
</script>

<template>
    <div>
        <h2>Skapa/Redigera Besöksunderlag</h2>
        <p>Id: {{ besoksunderlagId }}</p>
    </div>
</template>
